/*eslint-disable */

import ppLeftSidebar from '../paperpile-left-sidebar';

export default {
  name: 'awerack-root',
  components: {
    'pp-left-sidebar' : ppLeftSidebar,
  },
  props: [],
  data () {
    return {
      isMobile:false,
      mblLeftSidebaar:false,
      leftSidebarHideState:false
    }
  },
  computed: {

  },
  mounted () {

  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    leftSidebarHideMethod(){
      if(this.leftSidebarHideState){
        this.leftSidebarHideState = false
      }else{
        this.leftSidebarHideState = true
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    openMblLeftSideBar(){
     if( this.mblLeftSidebaar == true){
      this.mblLeftSidebaar = false
     }else{
      this.mblLeftSidebaar = true
     }
    },
    closeMblLeftSideBar(){
      this.mblLeftSidebaar = false
    }
  }
}


